/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Meta_PublishInputs */

const cs_enum_meta_publish = /** @type {(inputs: Enum_Meta_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikace na Meta`)
};

const en_enum_meta_publish = /** @type {(inputs: Enum_Meta_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta publish`)
};

/**
* | output |
* | --- |
* | "Meta publish" |
*
* @param {Enum_Meta_PublishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_meta_publish = /** @type {((inputs?: Enum_Meta_PublishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Meta_PublishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_meta_publish(inputs)
	return cs_enum_meta_publish(inputs)
});